import React, { FC, useEffect, useState } from 'react';
import HlsVideo from '../HlsVideo';
import { AccessMode, ConfigType } from '../type';
import { getEzvizTranscodeUrl, isEzopenUrl, shouldResolveEzvizUrl } from './ezviz';

interface EzvizProxyVideoProps {
  deviceId?: string | number;
  src?: string;
  accessMode?: number;
  configType?: number;
  height?: string | number;
  minHeight?: string | number;
  width?: string | number;
}

const EzvizProxyVideo: FC<EzvizProxyVideoProps> = ({
  deviceId,
  src,
  accessMode = AccessMode.YSY,
  configType = ConfigType.PROXY,
  height,
  minHeight,
  width,
}) => {
  const [playUrl, setPlayUrl] = useState<string>();

  useEffect(() => {
    let ignore = false;

    const needResolveEzvizUrl = shouldResolveEzvizUrl({
      accessMode,
      configType,
      url: src,
      deviceId,
    });

    if (needResolveEzvizUrl) {
      getEzvizTranscodeUrl(deviceId)
        .then(url => {
          if (!ignore) {
            setPlayUrl(url);
          }
        })
        .catch(() => {
          if (!ignore) {
            setPlayUrl(undefined);
          }
        });
      return () => {
        ignore = true;
      };
    }

    setPlayUrl(src && !isEzopenUrl(src) ? src : undefined);
    return () => {
      ignore = true;
    };
  }, [accessMode, configType, deviceId, src]);

  return <HlsVideo src={playUrl} height={height} minHeight={minHeight} width={width} />;
};

export default EzvizProxyVideo;
